<template>
  <div>
    <v-container fluid>
      <v-card>
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Ajuda</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-app-bar>
        <v-row class="px-5">
          <v-col cols="12" lg="4" sm="12" md="6">
            <v-card-title>{{produtos.titulo}}</v-card-title>
            <v-divider />
            <v-data-table
              hide-default-header
              hide-default-footer
              :headers="headers"
              :items="produtos.videos"
            >
              <template v-slot:item.nome="{item}">
                <v-btn
                  class="my-2"
                  color="primary"
                  fab
                  small
                  @click="abrirVideo(item.nome, item.titulo)"
                >
                  <v-icon dark>play_arrow</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-col>

          <v-col cols="12" lg="4" sm="12" md="6">
            <v-card-title>{{pedidos.titulo}}</v-card-title>
            <v-divider />
            <v-data-table
              hide-default-header
              hide-default-footer
              :headers="headers"
              :items="pedidos.videos"
            >
              <template v-slot:item.nome="{item}">
                <v-btn
                  class="my-2"
                  color="primary"
                  fab
                  small
                  @click="abrirVideo(item.nome, item.titulo)"
                >
                  <v-icon dark>play_arrow</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-col>

          <v-col cols="12" lg="4" sm="12" md="6">
            <v-card-title>{{outros.titulo}}</v-card-title>
            <v-divider />
            <v-data-table
              hide-default-header
              hide-default-footer
              :headers="headers"
              :items="outros.videos"
            >
              <template v-slot:item.nome="{item}">
                <v-btn
                  class="my-2"
                  color="primary"
                  fab
                  small
                  @click="abrirVideo(item.nome, item.titulo)"
                >
                  <v-icon dark>play_arrow</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card>
    </v-container>

    <as-dialogo ref="dialogoVideo" :title="titulo_video" max-width="1000px">
      <video width="100%" controls ref="video">
        <source :src="'video/tutoriais/' + nome_video + '.mp4'" type="video/mp4" />
      </video>
    </as-dialogo>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      nome_video: "",
      titulo_video: "",
      headers: [
        { text: "Vídeo", value: "titulo", width: "90%", sortable: false },
        {
          text: "",
          value: "nome",
          align: "right",
          sortable: false,
          width: "10%"
        }
      ],
      produtos: {
        titulo: "Produtos",
        videos: [
          {
            titulo: "Cadastrar Tamanhos",
            nome: "tamanhos_cadastrar"
          },
          {
            titulo: "Cadastrar Cores",
            nome: "cores_cadastrar"
          },
          {
            titulo: "Cadastrar Produto",
            nome: "produtos_cadastrar"
          },
          {
            titulo: "Editar Produto",
            nome: "produtos_editar"
          },
          {
            titulo: "Excluir Produto",
            nome: "produtos_excluir"
          }
        ]
      },
      pedidos: {
        titulo: "Pedidos",
        videos: [
          {
            titulo: "Cadastrar Pedido",
            nome: "pedidos_cadastrar"
          },
          {
            titulo: "Editar Pedido",
            nome: "pedidos_editar"
          },
          {
            titulo: "Copiar Pedido",
            nome: "pedidos_copiar"
          },
          {
            titulo: "Cancelar Pedido",
            nome: "pedidos_cancelar"
          },
          {
            titulo: "Imprimir Pedido - Ilha de Impressão",
            nome: "pedidos_impressaoremota"
          },
          {
            titulo: "Imprimir Pedido - Impressora Própria",
            nome: "pedidos_impressaolocal"
          }
        ]
      },
      outros: {
        titulo: "Outros",
        videos: [
          {
            titulo: "Alterar Senha",
            nome: "alterar_senha"
          }
        ]
      }
    };
  },
  mounted() {},
  methods: {
    abrirVideo(nome_video, titulo_video) {
      this.nome_video = nome_video;
      this.titulo_video = titulo_video;
      this.$refs.dialogoVideo.abrir();
      if (this.$refs.video) {
        this.$refs.video.load();
        this.$refs.video.play();
      }
    }
  },
  computed: {}
};
</script>

<style></style>
